import { render, staticRenderFns } from "./report-bulk-stock-hanwood.vue?vue&type=template&id=0ce165f8"
import script from "./report-bulk-stock-hanwood.vue?vue&type=script&lang=js"
export * from "./report-bulk-stock-hanwood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports